<!-- eslint-disable -->
<template lang="pug">
    .row.user-box
        .col-xs-12.col-md-3.user-box__avatar-container
            router-link(:to="{name: 'user:profile', params: {id: user.id, type: user.type}}")
                img.user-box__avatar(:src="user.avatar")
        .col-xs-12.col-md-9.user-box__info
            p.user-box__greeting
                | {{ userGreeting }}
                | &nbsp;
                img.user-box__emoji(:src="SmilingEmoji")
            p.user-box__schools
                template(v-if="user.isSuperadmin")
                    | {{ $i18n.t('dashboard.dashboard_user_superAdmin') }}
                template(v-else-if="user.isManagerOrSupport")
                    | {{ user.firstName }}
                template(v-else-if="user.school")
                    .user-box__school(v-for="school in user.schools")
                        svg-icon.user-box__icon(name="university", size="large")
                        | {{ school.name }}
                template(v-else)
                    | {{ $i18n.t('dashboard.dashboard_user_noSchool') }}
            router-link.hidden-lg(:to="{name: 'user:edit', params: {id: user.id, type: user.type}}")
                cs-button.user-box__button(color="white", :bold="true") {{ $i18n.t('dashboard.dashboard_user_edit') }}
        .col-xs-12.hidden-sm.hidden-xs.hidden-md.hidden-xl.no-padding
            router-link( :to="{name: 'user:edit', params: {id: user.id, type: user.type}}")
                cs-button(color="white", :bold="true") {{ $i18n.t('dashboard.dashboard_user_edit') }}
</template>

<script>
    /*eslint-disable*/
    import SmilingEmoji from '../../../assets/images/emoji/smiling-face.png';

    import {mapState} from 'vuex'

    export default {
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            userGreeting () {
                return this.$i18n.t('dashboard.dashboard_user_greeting', { name: this.user.firstName });
            }
        },
        data () {
            return {
                SmilingEmoji
            }
        }
    }
</script>

<style lang="scss" scoped>
    .user-box {
        padding: 30px 30px 20px 30px;
        margin: 0;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        background-color: var(--user-main-color);
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .user-box--female {
        background-color: $x-color-orange;
    }

    .user-box__greeting {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
        @include media($md) {
            justify-content: flex-start;
        }
    }

    .user-box__emoji {
        width: 22px;
        height: 22px;
    }

    .user-box__schools {
        font-size: 18px;
        line-height: 21px;
        color: $x-color-white;
        margin: 0;
    }

    .user-box__school {
        margin-top: 15px;
    }

    .user-box__info {
        margin-bottom: 20px;
        text-align: center;
        @include media($md) {
            text-align: left;
            padding-left: 30px;
        }
    }

    .user-box__avatar-container {
        margin-bottom: 20px;
        padding: 0;
        display: flex;
        justify-content: center;
    }

    .user-box__avatar {
        border-radius: 50%;
        max-height: none;
        height: 100px;
        width: 100px;
        border: 10px solid rgba($hsl-color-gray-100, 0.2);
        @include media($xlg) {
            height: 140px;
            width: 140px;
        }
    }

    .user-box__button {
        margin-top: 25px;
        padding: 15px 25px;
        @include media($sm) {
            padding: 15px 30px;
        }
    }

    .user-box__icon {
        margin-right: 5px;
    }
</style>
